module.exports = __webpack_public_path__ + "img/code@3x.b7386ebf.png";